export default "$ yarn add material-design-icons-iconfont -D\n// OR\n$ npm install material-design-icons-iconfont -D\n";